<div class="w-full h-full p-6 bg-white rounded-2xl shadow-sm">
  <div class="mb-6">
    <h2 class="text-2xl font-bold text-gray-800">Enviar Email</h2>
    <p class="text-sm text-gray-500 mt-1">Envía emails individuales o masivos a tus alumnos</p>
  </div>

  <!-- Mensaje informativo cuando se selecciona una plantilla -->
  <div *ngIf="templateSelected" class="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
    <div class="flex items-center gap-x-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <p class="text-sm text-green-800 font-medium">
        Plantilla seleccionada. El asunto y cuerpo del email se tomaran de la plantilla.
      </p>
    </div>
  </div>

  <app-generic-form
    #formComponent
    [genericForm]="genericForm"
    (onFinished)="onFormFinished($event)">
  </app-generic-form>
</div>
